import { useEffect, useState } from 'react';
import ParrotBox from '../../UI/ParrotBox';

const SentencePractiseWrapper = (props) => {
  let [blockClasses, setBlockClasses] = useState('sentence-wrapper');

  const initLoading = () => {
    //Update classes
    setBlockClasses('sentence-wrapper sentence-wrapper--active');

    //Scroll into view
    setTimeout(function () {
      let section = document.getElementById(
        `section-sentence-${props.sectionIndex}`,
      );
      const topPos =
        window.pageYOffset + section.getBoundingClientRect().top - 120;
      window.scrollTo({ top: topPos, behavior: 'smooth' });
    }, 300);
  };

  useEffect(() => {
    setTimeout(function () {
      initLoading();
    }, 50);
  }, []);

  return (
    <div id={`section-sentence-${props.sectionIndex}`} className={blockClasses}>
      <ParrotBox text={props.parrotText} bitesize={false} />
      {props.fullSentence && (
        <h4 className="sentence-wrapper__full">{props.fullSentence}</h4>
      )}
      {props.children}
    </div>
  );
};

export default SentencePractiseWrapper;
